import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";

// One help article (backend help_content/articles.json): question, short
// answer, numbered steps, and a button that opens the screen it's about. Used
// by the Help page and Getting Started's settings guide.
export default function HelpArticleCard({ article, defaultOpen = false, compact = false }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(defaultOpen);
  const link = article.link;
  const goes = link && link.path && link.path !== "/help";

  return (
    <div className={`rounded-2xl border bg-white transition-shadow ${open ? "border-primary-200 shadow-sm" : "border-secondary-200 hover:border-secondary-300"}`}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left">
        <span className={`font-medium text-secondary-900 ${compact ? "text-sm" : ""}`}>{article.title}</span>
        <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${open ? "bg-primary-50 text-primary-600" : "text-secondary-400"}`}>
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-4">
          <p className="text-sm text-secondary-700 leading-relaxed">{article.answer}</p>
          {article.steps?.length > 0 && (
            <ol className="space-y-2">
              {article.steps.map((s, i) => (
                <li key={s} className="flex gap-3 text-sm text-secondary-700">
                  <span className="w-6 h-6 shrink-0 rounded-full bg-primary-50 text-primary-700 text-xs font-bold flex items-center justify-center">{i + 1}</span>
                  <span className="pt-0.5">{s}</span>
                </li>
              ))}
            </ol>
          )}
          {goes && (
            <button type="button" onClick={() => navigate(link.path)}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-primary-600 text-white text-sm font-semibold hover:bg-primary-700">
              {link.label} <ArrowRight className="w-4 h-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
